import { ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initI18n } from '@tecma/i18n';

import defaultTranslation from 'i18n/en/translation.json';
import PageLoader from 'components/PageLoader/PageLoader';
import { environmentSelectors } from 'store/slices/environment/selectors';
import { i18nSelectors } from 'store/slices/i18n/selectors';
import { setI18nLoaded } from 'store/slices/i18n/reducer';

interface Props {
  children: ReactNode;
}

export const ProviderI18n = ({ children }: Props) => {
  const dispatch = useDispatch();
  const i18nLoaded = useSelector(i18nSelectors.i18nLoaded);
  const environment = useSelector(environmentSelectors.environment);

  useEffect(() => {
    initI18n(defaultTranslation, {
      bucketBase: `${environment.REACT_APP_BUCKET_BASEURL}`,
      productName: environment.REACT_APP_NAME,
      apiBase: environment.REACT_APP_API_URI ?? '',
      expirationTime: 1000 * 60,
      cache: 'no-cache',
    }).then(() => {
      dispatch(setI18nLoaded(true));
    });
  }, [environment.REACT_APP_BUCKET_BASEURL]);

  if (!i18nLoaded) return <PageLoader />;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
